import { render, staticRenderFns } from "./PricingDiscount.vue?vue&type=template&id=caf879de&scoped=true&"
import script from "./PricingDiscount.vue?vue&type=script&lang=js&"
export * from "./PricingDiscount.vue?vue&type=script&lang=js&"
import style0 from "./PricingDiscount.vue?vue&type=style&index=0&id=caf879de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf879de",
  null
  
)

export default component.exports